import React, { createContext, useContext, useState, useEffect } from "react";
import * as api from "../api";

const AnnoncesContext = createContext();

export const AnnoncesProvider = ({ children }) => {
  const [annonces, setAnnonces] = useState([]);
  const [loading, setLoading]   = useState(false);
  const [total, setTotal]       = useState(0);
  const [pages, setPages]       = useState(1);

  const fetchAnnonces = async (params = {}) => {
    setLoading(true);
    try {
      const res = await api.getAnnonces(params);

      // ✅ CORRECTION : vérifier que res.data.annonces existe et est un tableau
      const liste = Array.isArray(res.data?.annonces) ? res.data.annonces : [];

      // ✅ Annonces avec vraie image (pas placeholder) en premier
      const sorted = [...liste].sort((a, b) => {
        const aHasPhoto = a.image && !a.image.includes("unsplash") ? 1 : 0;
        const bHasPhoto = b.image && !b.image.includes("unsplash") ? 1 : 0;
        return bHasPhoto - aHasPhoto;
      });

      setAnnonces(sorted);
      setTotal(res.data?.total || 0);
      setPages(res.data?.pages || 1);
    } catch (err) {
      console.error("Erreur chargement annonces:", err);
      setAnnonces([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnnonces();
    // ✅ Rafraîchit les annonces toutes les 30 secondes
    const interval = setInterval(() => fetchAnnonces(), 5000);
    return () => clearInterval(interval);
  }, []);

  const getAnnonce     = async (id)       => { const res = await api.getAnnonce(id);         return res.data; };
  const getMesAnnonces = async ()         => { const res = await api.getMesAnnonces();        return res.data; };
  const createAnnonce  = async (data)     => { const res = await api.createAnnonce(data);     return res.data; };
  const updateAnnonce  = async (id, data) => { const res = await api.updateAnnonce(id, data); await fetchAnnonces(); return res.data; };
  const deleteAnnonce  = async (id)       => { await api.deleteAnnonce(id); await fetchAnnonces(); };
  const toggleStatut   = async (id)       => { const res = await api.toggleStatut(id); await fetchAnnonces(); return res.data; };

  return (
    <AnnoncesContext.Provider value={{
      annonces, loading, total, pages,
      fetchAnnonces, getAnnonce, getMesAnnonces,
      createAnnonce, updateAnnonce, deleteAnnonce, toggleStatut,
    }}>
      {children}
    </AnnoncesContext.Provider>
  );
};

export const useAnnonces = () => useContext(AnnoncesContext);
export default AnnoncesContext;